import { Component, Input } from '@angular/core';

@Component({
    selector: 'progress-bar',
    templateUrl: 'index.html'
})
export class ProgressBarComponent {
    @Input() title: string;
    @Input() height = '30px';
    @Input() width = '100%';
    @Input() data: any;
    @Input() cssClass: string;
    // If indeterminate, bypass some data and use different styles.
    // This is intended to behave similarly to Angular-Material's progress bar component.
    @Input() indeterminate: boolean;
    @Input() showText: boolean;

    constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/core/progress-bar/index.ts